// extracted by mini-css-extract-plugin
module.exports = {"headline":"rdg_d7698bad rdg_2c453a28","cta":"rdg_19967681"};